import React, { useState } from 'react';
import InputWithClear from '../../../Elements/InputComponents/InputWithClear';

// Controlled wrapper so the gallery can show a real, interactive <InputWithClear>
// without a Redux store or a backend. It holds the field value in local state and
// feeds InputWithClear's (fieldName, value) onChange contract straight back in.
// Only pass primitive input types here — data-bound selects fetch on mount and
// belong in the "Data-bound selects" reference entry instead.
export function LiveInput({ initialValue = null, ...rest }) {
  const [value, setValue] = useState(initialValue);
  const [editedItem] = useState({});
  return (
    <InputWithClear
      {...rest}
      value={value}
      editedItem={editedItem}
      onChange={(fieldName, newValue) => setValue(newValue)}
    />
  );
}

// One labelled demo row: an uppercase caption naming the input type, then the input.
export function InputRow({ label, children }) {
  return (
    <div className='dsg-row'>
      <div className='dsg-demo-label'>{label}</div>
      <div style={{ width: '100%', maxWidth: 440 }}>{children}</div>
    </div>
  );
}
